module.exports = __webpack_public_path__ + "static/media/text-width.8e4c695c.svg";